import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import SV from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client';

export function getEnvironment(useDbl = false) {
    // dbl.relayData is automatically injected into SV
    // if the route uses dbl.executeRelayQuery
    // if the route use a custom relay query fetch call
    // then create a custom SV to not stomp on the `dbl` SV
    const abtRelayData = SV.get(`${useDbl ? 'dbl' : 'abt'}.relayData`) || {};
    const relayData = { ...abtRelayData };
    const source = new RecordSource(relayData);
    const store = new Store(source);
    const network = Network.create(
        createFetcher({
            getQueries: () => ({
                ...getBuyerToken(document.cookie),
                locale: SV.get('locale'),
            }),
        })
    );

    return new Environment({
        network,
        store,
    });
}
